import { gql } from "@apollo/client";

export const PROGRAMMING_STRUCTURES_QUERY = gql`
  query programmingStructuresCube($scenarioId: ID!, $filter: ProgrammingStructureFilterInput!) {
    cube(scenarioId: $scenarioId) {
      programmingStructures(filter: $filter) {
        items {
          id
          code
          name
          subjectCodes
          campusCodes
          source
          programmingStructureStats {
            id
            isPublished
            isVisible
            __typename
          }
          totalBlockDuration
          programmingStructureParts {
            id
            blockDuration
            dependenciesCodes
            programmingStructureStage {
              id
              name
              code
              programmingStructureStageType {
                id
                code
                name
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
